import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import * as Sentry from "@sentry/browser";

if(process.env.NODE_ENV === 'production'){
    Sentry.init({
        dsn: "https://64d284f0dc144e628727003e26c0d27d@sentry.io/1312941"
    });
}
// Wrap the rendering in a function:
const render = () => {
    ReactDOM.render(
        // Wrap App inside AppContainer

        <App />,
        document.getElementById("root")
    );
};

// Do this once
registerServiceWorker();

// Render once
render();



// WEBPACK FOOTER //
// ./src/index.js